<template>
	<div class="content">
		<section class="head-section">
			<div class="container cols-2">
				<div class="images-col"
				data-aos="opacity-animation" 
				data-aos-duration="2000">
					<picture class="full-image">
						<source srcset="../assets/images/office-1-mob.jpg 1x ../assets/images/office-1-mob2x.jpg 2x" type="image/jpg" media="(max-width: 440px)">
						<source srcset="../assets/images/office-1-mob.webp 1x ../assets/images/office-1-mob2x.webp 2x" type="image/webp" media="(max-width: 440px)"> 
						<source srcset="../assets/images/office-1.webp" type="image/webp">
						<img src="../assets/images/office-1.jpg" alt="Lember Flowers" width="547" height="596">
					</picture>
					<picture class="img-center">
						<source srcset="../assets/images/office-2.webp" type="image/webp">
						<img src="../assets/images/office-2.jpg" alt="Flowers" :ref="setImagemRef">
					</picture>
				</div>
				<div class="content-col">
					<h1 class="title"
					data-aos="fade-right"
					data-aos-duration="1000">Озеленення офісів</h1>
					<div class="content">
						<p
						data-aos="fade-left"
					data-aos-duration="1000">Внутрішнє озеленення офісних приміщень, продумане до деталей фітодизайнером</p>
						<router-link to="#consultation" class="btn"
						data-aos="fade-right"
						data-aos-duration="1000">ХОЧУ КОНСУЛЬТАЦІЮ</router-link>
					</div>
				</div>
			</div>
		</section>
		<section class="advantages">
			<div class="container">
				<div class="flower-bg"></div>
				<h2 class="title">Для чого це взагалі?</h2>
				<div class="conunts">
					<div class="count-item">
						<p>БІЛЬШЕ НІЖ ВДОМА</p>
						<span>ПРАЦІВНИКИ ПРОВОДЯТЬ В ОФІСІ ВІД 40 ГОДИН НА ТИЖДЕНЬ</span>
					</div>
					<div class="count-item">
						<p>ЕКОЛОГІЯ</p>
						<span>БАГАТО ПРАЦІВНИКІВ - БАГАТО ВУГЛЕКИСЛОГО ГАЗУ</span>
					</div>
					<div class="count-item"><p>ПРОДУКТИВНІСТЬ</p><span>ОДНОМАНІТНИЙ ІНТЕР'ЄР ВИСНАЖУЄ І ЗНИЖУЄ ПРАЦЕЗДАТНІСТЬ</span></div>
				</div>
			</div>
		</section>
		<section class="bg-section">
			<div class="container cols-2 info-container">
				<div class="content-col ">
					<h2 class="title">Ми знаємо як допомогти</h2>
					<div class="content">
						<p>Квіти та зелень покращують мікроклімат у приміщенні, ефективність працівників підвищується, з ними офіс виглядатиме естетичнішим, а працівникам приємніше працювати в атмосфері хоча б частково наближеній до природи. Фітодизайн комерційного приміщення покращує імідж компанії та доповнює інтер'єр. А ще  рослини можна використати для зонування приміщення.</p>
					</div>
				</div>
				<div class="images-col">
					<picture class="full-image">
						<source srcset="../assets/images/office-3.webp" type="image/webp">
						<img src="../assets/images/office-3.jpg"  alt="Lember Flowers" :ref="setImagemRef">
					</picture>		
					<picture class="img-center">
						<source srcset="../assets/images/office-4.webp" type="image/webp">
						<img src="../assets/images/office-4.jpg"  alt="Lember Flowers" :ref="setImagemRef">
					</picture>
						
						
				</div>
			</div>
		</section>
		<section class="trust-section">
			<div class="container">
				<h2 class="title">Чому нам можна довіряти?</h2>
				<div class="trust-wrap">
					<div class="cols-2">
						<div>
							<h3 class="title">КІЛЬКІСТЬ</h3>
							<p>У нашому квітковому господарстві одночасно знаходиться більше 5000 рослин.</p>
						</div>
						<div>
							<h3 class="title">ЯКІСТЬ</h3>
							<p>Ми не просто прикрашаємо офіси наявними в нас рослинами - ми підбираємо композиції під кожен конкретний об'єкт і за потреби вирощуємо необхідні рослини. А після монтажу детально роз'яснюємо як за ними правильно доглядати.</p>
						</div>
					</div>
				</div>
			</div>
		</section>
		<section>
			<div class="container">
				<div class="gallery">
					<div v-for="(img, index) in gallery"
					:key="index" :class="'pic'"
					@click="() => showGalleryImg(index)">
						<picture>
							<source :srcset="typeof img === 'string' ? img : img.thumbnailWebp" type="image/jpg" media="(max-width: 440px)">
							<source :srcset="typeof img === 'string' ? img : img.thumbnailMob" type="image/webp" media="(max-width: 440px)">
							<source :srcset="typeof img === 'string' ? img : img.webp" type="image/webp">
							<img :src="typeof img === 'string' ? img : img.thumbnail"  alt="image gallery" :ref="setImagemRef">
						</picture>
					</div>
				</div>
				<vue-easy-lightbox
					:visible="visibleImg"
					:imgs="gallery"
					:index="indexGallery"
					:moveDisabled = "moveDisabled"
					:scrollDisabled = "scrollDisabled"
					:swipeTolerance = "swipeTolerance"
					:escDisabled="escDisabled"
					:loop="loop"
					@hide="handleGalleryHide">
					</vue-easy-lightbox>
			</div>
		</section>
		<section class="video-section">
			<div class="bg-video">
				<video loop="loop" autoplay="autoplay" preload="auto" muted="muted" playsinline="" class="screen-video" :data-src="video" :src="video"></video>
			</div>
			<div class="container cols-2 conunts">
				<div><h2 class="title">Як це працює?</h2></div>
				<div class="cols-2">
					<div class="count-item">
						<p>Консультація по телефону</p>
						<span>Фіксуємо потреби клієнта, обговорюємо варіанти реалізації, узгоджуємо орієнтовні об'єми роботи і кошторис.</span>
					</div>
					<div class="count-item">
						<p>Виїзд фотографа і дизайнера</p>
						<span>Зустріч з клієнтом на об'єкті. Фотофіксація та детальне обговорення побажань клієнта.</span>
					</div>
					<div class="count-item">
						<p>Пропозиція</p>
						<span>Підготовка рендерів об'єкта з варіантами реалізації.</span>
					</div>
					<div class="count-item">
						<p>Доставка і монтаж</p>
						<span>Згідно проєкту все доставляємо і монтуємо на місці.</span>
					</div>
				</div>
			</div>
		</section>
		<section>
			<div class="container">
				<v-form/>
			</div>
		</section>
		<section>
			<v-contacts/>
		</section>
	</div>
</template>

<style scoped lang="scss">
	@import "../assets/scss/components/office-page.scss";
</style>

<script>
	import ContactForm from '@/components/ContactForm.vue'
	import Contacts from '@/components/Contacts.vue'
	import VueEasyLightbox from 'vue-easy-lightbox' 

	import { ref, onMounted, onBeforeUpdate } from 'vue'


export default {
	setup() {
		let imageRefs = ref([])
		const setImagemRef = el => {
			if (el) {
				imageRefs.value.push(el)
			}
		}
	onMounted(() => {
		imageRefs.value.forEach(function(entry) {
			entry.width = entry.clientWidth
			entry.height = entry.clientHeight
		});
	})
	onBeforeUpdate(() => {
		imageRefs.value = []

	})
		return {
			setImagemRef
		}
	},
	components: {
		VueEasyLightbox,
		'v-contacts': Contacts,
		'v-form': ContactForm,
	},
	data(){
		return {
			visibleImg: false,
			indexGallery: 0,
			moveDisabled:true,
			scrollDisabled : true,
			swipeTolerance : 50,
			escDisabled : true,
			loop: true,
			gallery: [
				{
					src: require('../assets/images/office-gallery/image-1.jpg'),
					webp: require('../assets/images/office-gallery/small-1.webp'),
					thumbnail: require('../assets/images/office-gallery/small-1.jpg'),
					thumbnailMob: require('../assets/images/office-gallery/small-mob-1.jpg'),
					thumbnailWebp: require('../assets/images/office-gallery/small-mob-1.webp')
				},
				{
					src: require('../assets/images/office-gallery/image-2.jpg'),
					webp: require('../assets/images/office-gallery/small-2.webp'),
					thumbnail: require('../assets/images/office-gallery/small-2.jpg'),
					thumbnailMob: require('../assets/images/office-gallery/small-mob-1.jpg'),
					thumbnailWebp: require('../assets/images/office-gallery/small-4.webp')
				},
				{
					src: require('../assets/images/office-gallery/image-3.jpg'),
					webp: require('../assets/images/office-gallery/small-3.webp'),
					thumbnail: require('../assets/images/office-gallery/small-3.jpg'),
					thumbnailMob: require('../assets/images/office-gallery/small-mob-1.jpg'),
					thumbnailWebp: require('../assets/images/office-gallery/small-4.webp')
				},
				{
					src: require('../assets/images/office-gallery/image-4.jpg'),
					webp: require('../assets/images/office-gallery/small-4.webp'),
					thumbnail: require('../assets/images/office-gallery/small-4.jpg'),
					thumbnailMob: require('../assets/images/office-gallery/small-mob-1.jpg'),
					thumbnailWebp: require('../assets/images/office-gallery/small-4.webp')
				},
			],
			video: require('../assets/images/AdobeStock_1.mp4')
		}
	},
	methods: {
		showGalleryImg(index) {
			this.indexGallery = index
			this.visibleImg = true
		},
		handleGalleryHide() {
			this.visibleImg = false
		}
	}
}
</script>